export default __webpack_public_path__ + "static/media/architecture-img-16.5cc62074.jpg";